// HTTP 轮询配置文件
export const httpPollingConfig = {
  // 轮询间隔（毫秒）
  interval: 3000, // 默认3秒

  // API 基础地址
  baseUrl: "http://live.api.supershooter.cn/api/live",
  matchesUrl: "http://live.api.supershooter.cn/api/live/matches",
  filterUrl: "http://live.api.supershooter.cn/api/live/filter",
  // matchesUrl: "http://192.168.27.136:8017/api/live/matches",
  // filterUrl: "http://192.168.27.136:8017/api/live/filter",

  // 重试配置
  maxRetries: 3, // 最大重试次数
  retryDelay: 1000, // 重试延迟（毫秒）

  // 超时配置
  timeout: 10000, // 请求超时时间（毫秒）

  // 是否在页面隐藏时暂停轮询
  pauseOnHidden: true,

  // 是否显示连接状态指示器
  showStatusIndicator: true,

  // 调试模式
  debug: true,
};

// 导出修改配置的方法
export const updateConfig = (newConfig) => {
  Object.assign(httpPollingConfig, newConfig);
};
